import { Component, Label, _decorator } from 'cc';
import TableModel from '../../../../../tableEngine/Script/Game/Data/Model/TableModel';

const { ccclass, property } = _decorator;

@ccclass('BaseMachineInfo')
export default class BaseMachineInfo extends Component {
    @property(Label)
    protected readonly machineInfoLabel: Label = null;

    @property
    protected readonly useTwoLabels: boolean = false;

    @property({
        type: Label,
        visible(this: BaseMachineInfo) {
            return this.useTwoLabels;
        },
    })
    protected readonly machineIDLabel: Label = null;

    public updateInfo({ tableID, machineName }: TableModel): void {
        if (this.useTwoLabels) {
            this.machineInfoLabel.string = machineName;
            this.machineIDLabel.string = tableID.toString();
        } else {
            this.machineInfoLabel.string = `${machineName} (${tableID})`;
        }
    }
}
